var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmeMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 245,
    viewBox: "0 0 186 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 176,
    height: 235,
    stroke: "black",
    strokeWidth: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 29.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 69,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 69.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 29.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 69,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 69.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 109,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 109.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 149,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 149.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 189,
    width: 25,
    height: 22,
    rx: 5,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 189.5,
    width: 100,
    height: 21,
    rx: 4.5,
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeMenu);
export default __webpack_public_path__ + "static/media/gme-menu.9583e08df4ddd27ebfe52b517151031c.svg";
export { ForwardRef as ReactComponent };